import { render, staticRenderFns } from "./editarDadosImportacao.vue?vue&type=template&id=be4c6466&scoped=true&"
import script from "./editarDadosImportacao.vue?vue&type=script&lang=js&"
export * from "./editarDadosImportacao.vue?vue&type=script&lang=js&"
import style0 from "./editarDadosImportacao.vue?vue&type=style&index=0&id=be4c6466&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4c6466",
  null
  
)

export default component.exports